export type EngageMenuItem<T extends readonly any[]> = T[number]

export type EngageEmail = {
  message_id: string
  thread_id: string
  user_id: number
  sender_email: any
  to: string
  body: string
  sent_at: string
  message_status: string
  is_read: boolean
  subject: string
  tenant_id: number
}

export enum EmailListType {
  INSIDE_SALES = "inside-sales",
  PLATFORM = "PLATFORM"
}
